import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import DiarioService from '../../../../services/diario-auth';
import InfiniteScroll from '../../utils/infiniteScroll';
import Diario from './diario';


const ListarDiarios = () => {

    async function fetchDiarios() {
        await seraQueAcabou();
        const response = await DiarioService.listar({ limit: true, cod_diario: cod });
        if (response.data.length >= 1) {
            let count = Math.floor(numDiarios / 20) + 1
           for (let i = 1; i < count; i++) {
                setDiarios([...diarios, ...response.data])
                setCod(response.data[response.data.length-1]["cod_diario"])
                if (response.data.length < 20) {
                    setAindaTem(false)
                }
           }
        } else {
            setDiarios([])
            setVazio(true)
        }
    }
    
    const [diarios, setDiarios] = useState([]);
    const [arquivo, setArquivo] = useState(false);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [diario, setDiario] = useState("");
    const [cod, setCod] = useState(null);
    const [numDiarios, setNumDiarios] = useState(null);
    const [aindaTem, setAindaTem] = useState();



    async function fetchDiariosIn() {
        await pegaNumDiarios();
        const response = await DiarioService.listar({limit: true});
        if (response.data.length >= 1) {
            setDiarios(response.data)
            setVazio(false)
            setCod(response.data[response.data.length-1]["cod_diario"])
            if (response.data.length == 20) {
                setAindaTem(true)
            } else {
                setAindaTem(false)
            }
        } else {
            setDiarios([])
            setVazio(true)
        }
    }

    async function pegaNumDiarios() {
        const response = await DiarioService.numDiarios({ todas: true })
        setNumDiarios(parseInt(response.data))
    }

    const seraQueAcabou = async () => {
        if (diarios.length >= numDiarios + 1) {
            setAindaTem(false)
        } else {
            setAindaTem(true)
        }
    }

    const handleEditar = (id) => {
        setDiario(id);
        setEditar(true)
    }


    const handleArquivo = (id) => {
        setDiario(id);
        setArquivo(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a edição?')) {
            await DiarioService.deletar(id)
            alert("Edição deletada com sucesso!")
            fetchDiarios();
        }
    }

    useEffect(() => {
        fetchDiariosIn();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/diario/editar/${diario}`} />
        )
    } else if (arquivo) {
        return (
            <Navigate to={`/restrito/diario/arquivo/${diario}`} />
        )
    } 
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setDiarios={setDiarios}
                        setVazio={setVazio}
                        setAindaTem={setAindaTem}
                        fetchDiariosIn={fetchDiariosIn}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={4}>
                            {diarios.map((diario, index) =>
                                <Diario
                                    fetchDiariosIn={fetchDiariosIn}
                                    diario={diario}
                                    key={index}
                                    editar={handleEditar}
                                    arquivo={handleArquivo}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                        {aindaTem ?
                            <Fragment>
                                <p>Carregando mais edições...</p>
                                <InfiniteScroll Listar={fetchDiarios} />
                            </Fragment>
                            : <p>Todas as edições já foram exibidas :)</p>}
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarDiarios;